import * as React from "react";
const SvgFiRrAlien = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-alien_svg__a)">
      <path
        fill="#062147"
        d="M12 0C6.486 0 2 4.432 2 9.88c0 5.184 4.58 10.39 7.311 13.033A3.86 3.86 0 0 0 12 24.007c.967 0 1.936-.365 2.689-1.094C17.419 20.27 22 15.064 22 9.88 22 4.432 17.514 0 12 0m1.299 21.475a1.86 1.86 0 0 1-2.598 0C8.199 19.053 4 14.326 4 9.88 4 5.535 7.589 2 12 2s8 3.535 8 7.88c0 4.446-4.199 9.173-6.701 11.595m4.699-12.362c-.054.905-.27 2.152-1.002 2.883-.732.732-1.978.948-2.883 1.002a1.05 1.05 0 0 1-1.111-1.111c.054-.905.27-2.152 1.002-2.883.732-.732 1.978-.948 2.883-1.002a1.05 1.05 0 0 1 1.111 1.111m-7 2.775a1.05 1.05 0 0 1-1.111 1.111c-.905-.054-2.152-.27-2.883-1.002-.732-.732-.948-1.978-1.002-2.883a1.05 1.05 0 0 1 1.111-1.111c.905.054 2.152.27 2.883 1.002.732.732.948 1.978 1.002 2.883"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-alien_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAlien;
